angular.module('app').controller('DetailsModalController',['$scope','webservice',
                                            function($scope,webservice) {
  var script='public/reservationC';

  $scope.parentProceed = function(shortTermBasket,collections,params) {
    var model={};
    webservice.exclusiveCall('validateEvents',params,script,model).then(function() {
      for(var i in model.items) {
        collections.items[i]=model.items[i];
      }
      $scope.$close({'shortTermBasket':shortTermBasket,'collections':collections});
    });
  };

  $scope.confirmWording={'en':'Validate','nl':'Valideer','fr':'Valider'};

}]);
